import React from 'react';
import styled from 'styled-components';
import { utils } from '@makeship/core';
import { Caption } from '../Typography';
import { parseFeaturedCollectionMetafields } from '../../utils/collections';
import { parseProductMetafieldsFromCollection } from '../../utils/product';
import CreatorCardContainer from '../CreatorCard';

const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  padding: 0 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.largeTablet}px) {
    padding: 0 64px;
  }
`;

type CreatorGridProps = {
  creatorCollections: CollectionEdgeResponse[];
  sectionName: string;
  isComingSoon?: boolean;
};

const CreatorGrid: React.FC<CreatorGridProps> = ({
  creatorCollections,
  sectionName,
  isComingSoon,
}: CreatorGridProps) => {
  const renderCarouselItems = () =>
    creatorCollections.map((collection) => {
      const { node: creatorCollection } = collection;
      const { metafields } = creatorCollection;
      const { creatorLogoURL, creatorAvatarURL } = parseFeaturedCollectionMetafields(metafields.edges);
      const creatorLogoSrc = creatorLogoURL || creatorAvatarURL;
      const productMetafields =
        (creatorCollection.products?.[0]?.node?.metafields as Shopify.MetafieldConnection | undefined)?.edges ?? [];
      const { launch } = parseProductMetafieldsFromCollection(productMetafields);
      const launchDate = utils.getDateLocalCustomFormat(launch || '', 'MMM D');

      return (
        <div key={creatorCollection.id} className="flex flex-[0_0_auto] flex-col items-center text-center">
          <CreatorCardContainer
            fullName={creatorCollection.title || ''}
            src={creatorLogoSrc}
            href={`/shop/creator/${creatorCollection.handle}`}
            collectionHandle={creatorCollection.handle}
            sectionName={sectionName}
          />
          {isComingSoon && !!launch && <Caption>🗓️ {launchDate}</Caption>}
        </div>
      );
    });

  return <GridContainer>{renderCarouselItems()}</GridContainer>;
};

export default CreatorGrid;
